import { render, staticRenderFns } from "./RatingsGivenTab.vue?vue&type=template&id=582b9e5a&scoped=true"
import script from "./RatingsGivenTab.vue?vue&type=script&lang=js"
export * from "./RatingsGivenTab.vue?vue&type=script&lang=js"
import style0 from "./RatingsGivenTab.vue?vue&type=style&index=0&id=582b9e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582b9e5a",
  null
  
)

export default component.exports